'use strict';

var ConfigurationEventsDirective = function ConfigurationEventsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-events.html'),
    controller: 'ConfigurationEventsController',
    link: function link(scope) {
      scope.$on('configuration-events:saveChanges', scope.saveChanges);
    }
  };
};
ConfigurationEventsDirective.$inject = [];
module.exports = ConfigurationEventsDirective;